import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Privilege } from "../Shared/privilege";

@Injectable({
  providedIn: 'root'
})
export class PrivilegeService {

  selectedPrivilege: Privilege;
  // privilegeList: Privilege[];
  privilegeList: Array<Privilege> = [];

  constructor(private httpClient: HttpClient) { }

  getBaseUrl() {  
    return environment.baseUrl;
  }  

  IUDPrivilege(formValue: any) {

    this.privilegeList =[];
    for (let i = 0; i < formValue.privilegeList.length; i++) {
      
      let privilege = new Privilege();
      privilege.Id =+ formValue.frmId;
      privilege.RoleId = formValue.frmRoleId;
      privilege.IsActive = formValue.frmActive;     

      privilege.DocumentId = formValue.privilegeList[i].DocumentId;
      privilege.DocumentName = formValue.privilegeList[i].DocumentName; 
      privilege.IsMenu =formValue.privilegeList[i].IsMenu;    
      privilege.IsAdd = formValue.privilegeList[i].IsAdd;
      privilege.IsEdit = formValue.privilegeList[i].IsEdit;
      privilege.IsDelete = formValue.privilegeList[i].IsDelete;
      privilege.IsView = formValue.privilegeList[i].IsView;

      privilege.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
      privilege.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
      privilege.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
      privilege.SaasId =  JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
      privilege.CreatedDate  = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
      privilege.ModifiedDate = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];

      this.privilegeList.push(privilege);
    }

    let body = this.privilegeList;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Privilege/IUDList', body, { headers: headers });
  }

  GetPrivilegebyRoleId(RoleId : any){

    this.selectedPrivilege = new Privilege();
    this.selectedPrivilege.ListByRoleId = false; // for choosing SP only
    this.selectedPrivilege.RoleId = + RoleId;
    this.selectedPrivilege.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedPrivilege.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedPrivilege.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedPrivilege.SaasId =  JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    let body = this.selectedPrivilege;

    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Privilege/FetchList', body, { headers: headers });
  }

  GetPrivilegeList(){
 
    this.selectedPrivilege = new Privilege();
    this.selectedPrivilege.ListByRoleId = true; // for choosing SP only -- default listing
    this.selectedPrivilege.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedPrivilege.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedPrivilege.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedPrivilege.SaasId =  JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    let body = this.selectedPrivilege;

    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Privilege/FetchList', body, { headers: headers });
  }

  // Checking page permissions
  GetPageSecuritybyRoleId(DocumentId: number){
 
    this.selectedPrivilege = new Privilege();
    this.selectedPrivilege.ListByRoleId = false; // for choosing SP only, choosing by documentId
    this.selectedPrivilege.DocumentId = + DocumentId;
    this.selectedPrivilege.RoleId = + JSON.parse(localStorage.getItem("EmployeeData"))["RoleId"];
    this.selectedPrivilege.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedPrivilege.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedPrivilege.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedPrivilege.SaasId =  JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    let body = this.selectedPrivilege;

    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Privilege/Fetch', body, { headers: headers });
  }
}
